import discounts from "./administration/discounts";
import invoices from "./administration/invoices";
import debtor from "./customers/debtor";
import debtorGroup from "./customers/debtor-group";
import debtorGroups from "./customers/debtor-groups";
import debtors from "./customers/debtors";
import userManagement from "./customers/user-management";
import ipBlacklist from "./management/ip-blacklist";
import nsGroups from "./management/ns-groups";
import pbsLocations from "./management/pbs-locations";
import slaOverview from "./management/sla-overview";
import productGroups from "./products/product-groups";
import products from "./products/products";

const back_office = {
	/* ------------------------------ ADMINSTRATION ----------------------------- */
	administration: {
		discounts: discounts,
		invoices: invoices,
		title: "Administration",
	},
	/* -------------------------------- CUSTOMERS ------------------------------- */
	customers: {
		debtor: debtor,
		debtor_group: debtorGroup,
		debtor_groups: debtorGroups,
		debtors: debtors,
		title: "Customers",
		user_management: userManagement,
	},
	impersonate: {
		leave: "Impersonate stoppen",
	},
	/* ------------------------------- MANAGEMENT ------------------------------- */
	management: {
		ip_blacklist: ipBlacklist,
		ns_groups: nsGroups,
		pbs_locations: pbsLocations,
		sla_overview: slaOverview,
		title: "Management",
	},
	/* -------------------------------- PRODUCTS -------------------------------- */
	products: {
		product_groups: productGroups,
		products: products,
		title: "Products",
	},
	/* --------------------------------- BASICS --------------------------------- */
	title: "Back office",
};

export default back_office;
